var _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChchnya(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 450,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h450v300H0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#da251d",
    d: "M42 204.2h409v96H42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b7338",
    d: "M42 0h409v177.2H42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fc0",
    strokeWidth: 2,
    transform: "translate(-.58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M22.26 85.84c-3.6.9-5.6 5.42-3 9.33 2.9 4.52 9.6 4.21 13-.5s1.7-11.24-2.6-15.25c-5.3-4.92-14.2-4.01-18.4 2.91-5.2 8.73-1 18.26 4.8 24.98l10.7 10.54c5.8 6.72 10.1 16.26 4.8 24.98-4.1 6.92-13 7.93-18.2 3.11-4.4-4.11-6.1-10.54-2.7-15.25s10.1-5.02 13-.5c2.5 3.91.6 8.43-3 9.33"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 150,
    strokeWidth: 3.97,
    transform: "matrix(1 0 0 1.0087 0 -77.634)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 4.01,
    d: "M22.08 11.6c-3.6.9-5.6 5.42-3 9.33 2.9 4.52 9.6 4.21 13-.5s1.7-11.24-2.6-15.25c-5.3-4.92-14.2-4.01-18.4 2.91-5.2 8.73-1 18.26 4.8 24.98l10.7 10.53c5.8 6.72 10.1 16.25 4.8 24.98-4.1 6.92-13 7.93-18.2 3.11-4.4-4.11-6.1-10.53-2.7-15.25s10.1-5.02 13-.5c2.5 3.91.6 8.43-3 9.33m2.16 169.61c-3.6.9-5.6 5.42-3 9.33 2.9 4.52 9.6 4.21 13-.5s1.7-11.24-2.6-15.25c-5.3-4.92-14.2-4.01-18.4 2.91-5.2 8.73-1 18.26 4.8 24.98l10.7 10.54c5.8 6.72 10.1 16.25 4.8 24.98-4.1 6.92-13 7.93-18.2 3.11-4.4-4.11-6.1-10.54-2.7-15.25s10.1-5.02 13-.5c2.5 3.91.6 8.43-3 9.33"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChchnya);
export default __webpack_public_path__ + "static/media/chchnya.defe3e082eaaf1cd747e071345ed932e.svg";
export { ForwardRef as ReactComponent };